//import 'webpack-jquery-ui';
import 'webpack-jquery-ui/slider';
import 'jquery-ui-touch-punch'

var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';


    var initializeBlock = function ($block) {


        function RenderBackground() {
            if (method == 'front') {
                let w = jQuery(window).width();
                $('.block-newsletter').outerWidth(w);
            }
        }

        RenderBackground();

        // Resize
        // ---------------------------------------------------------------------------------------------------

        $(window).on('resize', function () {
            RenderBackground();

        });


    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=newsletter', initializeBlock);
    }
});
